<template>
  <v-container style="background: url(/assets/background.jpg);" fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <div style="text-align:center;">
          <img src="/assets/logo.png" alt srcset />
        </div>
        <v-tabs color="primary" right>
          <v-tab>Já tenho cadastro</v-tab>
          <v-tab>Quero me cadastrar</v-tab>

          <v-tab-item key="1">
            <v-card class="elevation-12">
              <v-card-text>
                <v-form v-model="validLogin">
                  <v-text-field
                    prepend-icon="mail"
                    name="email"
                    label="E-Mail"
                    type="text"
                    v-model="email"
                    :rules="[v => !!v || 'E-Mail é obrigatório!']"
                    required
                  />
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Senha"
                    type="password"
                    v-model="password"
                    :rules="[v => !!v || 'Senha é obrigatório!']"
                    required
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" :disabled="!validLogin" @click.native="login">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <v-tab-item key="2">
            <v-card class="elevation-12">
              <v-card-text>
                <v-form v-model="validRegister">
                  <v-text-field
                    prepend-icon="person"
                    name="name"
                    label="Nome"
                    type="text"
                    v-model="name"
                    :rules="[v => !!v || 'Nome é obrigatório!']"
                    required
                  />
                  <v-text-field
                    prepend-icon="mail"
                    name="email"
                    label="E-Mail"
                    type="text"
                    v-model="email"
                    :rules="[v => !!v || 'E-Mail é obrigatório!']"
                    required
                  />
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Senha"
                    type="password"
                    v-model="password"
                    :rules="[v => !!v || 'Senha é obrigatório!', v => v.length > 5 || 'Senha muito fraca!']"
                    required
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" :disabled="!validRegister" @click.native="register">Cadastrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>

        <br />
        <v-btn color="blue" dark @click.native="facebook" mr-4>FACEBOOK</v-btn>
        <v-btn color="red" dark @click.native="google">GOOGLE</v-btn>
      </v-flex>
    </v-layout>

    <dialog-loader :active="loading"></dialog-loader>
  </v-container>
</template>

<script>
import { authService, socialLogin } from "../plugins/firebase";
export default {
  // https://vuejsexamples.com/button-morphing-into-form/
  data: () => ({
    loading: true,
    validLogin: false,
    validRegister: false,
    name: "",
    email: "",
    password: ""
  }),
  created() {
    this.checkLogged();
    //console.log(DeviceUUID.parse());
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        //window.location.href = "/home";
      } else {
        //console.log("deslogado");
      }
      this.loading = false;
    });
  },
  methods: {
    async checkLogged() {
      if (await authService.authenticated()) {
        window.location.href = "/home";
      } else {
        this.loading = false;
      }
    },
    register() {
      this.loading = true;
      this.$auth
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(res => {
          //console.log(res);
          return this.registerApi(this.name, this.email, res.user.uid);
        })
        .catch(err => {
          this.loading = false;
          console.log("erroooooooo", err);
          switch (err.code) {
            case "auth/account-exists-with-different-credential":
            case "auth/credential-already-in-use":
            case "auth/email-already-in-use":
              alert("Este e-mail já possui conta! Faça seu login.");
              break;
            default:
              alert(
                "Ocorreu uma falha, verifique sua conexão e tente novamente."
              );
              break;
          }
        });
    },
    async login() {
      this.loading = true;
      this.$auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(async res => {
          return this.auth(res.user);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          alert("O endereço de email ou a senha que você inseriu não é válido");
        });
    },
    facebook() {
      this.loading = true;
      socialLogin
        .facebook()
        .then(res => {
          return this.registerApi(res.user.displayName, res.user.email, res.user.uid);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          alert("Falha ao tentar entrar com o Facebook. Tente novametne!");
        });
    },
    google() {
      this.loading = true;
      socialLogin
        .google()
        .then(res => {
          return this.registerApi(res.user.displayName, res.user.email, res.user.uid);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          alert("Falha ao tentar entrar com o Facebook. Tente novametne!");
        });
    },
    async auth(user) {
      const params = {
        firebase_id: user.uid,
        device_name: DeviceUUID.parse().browser,
        device_id: DeviceUUID.get(),
        platform: "web"
      };
      let config = {
        headers: {
          Authorization: "Bearer " + (await user.getIdToken())
        }
      };
      return this.$http
        .post(this.$SERVE + "/students/auth", params, config)
        .then(response => {
          this.loading = false;
          window.location.href = "/home";
        })
        .catch(err => {
          this.loading = false;
          if (err.response.data && err.response.data.message) {
            alert(err.response.data.message);
          } else {
            alert("Ocorreu uma falha, tente novamente!");
          }
        });
    },
    registerApi(name, email, firebase_id) {
      const params = {
        name,
        email,
        firebase_id,
        device_name: DeviceUUID.parse().browser,
        device_id: DeviceUUID.get(),
        platform: "web"
      };
      return this.$http
        .post(this.$SERVE + "/students/register", params)
        .then(response => {
          this.loading = false;
          window.location.href = "/home";
        })
        .catch(err => {
          if (error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          } else {
            alert("Ocorreu uma falha, tente novamente!");
          }
        });
    }
  }
};
</script>
